/**
 * Definiert Model der v3sConnectionAufgabe
 * @class service_v3sConnectionElement
 * @memberOf v3sWbtPlayerApp:exercise:connectable
 */
angular.module('v3sWbtPlayerApp').factory('v3sConnectionElement', ['v3sExerciseService', 'v3sExerciseElement', function (v3sExerciseService,v3sExerciseElement) {
    /**
     * @memberOf v3sWbtPlayerApp:exercise:connectable.service_v3sConnectionElement
     * @param {string} from - ID des Startelements
     * @param {string} to - ID des Endelements
     * @param {boolean} isCorrectAnswer - zeigt an, ob es eine korrekte Antwort ist
     * @param {object} element - das DOM-Element, welches beschrieben wird
     * @constructor
     */
    var v3sConnectionElement = function (id, from, to,isCorrectAnswer, element) {
        this.id = id;
        this.from = from;
        this.to = to || null;
        this.isCorrectAnswer = isCorrectAnswer;
        this.element = element;
        this.isCorrect = false;
        this.isDrawn = false; //Ist das Element bereits im DOM sichtbar
        this.userAnswer = {
            from: null,
            to: null 
        };
        this.status = this.STATUS.NO_ANSWER;
        this.load();
    }

    v3sConnectionElement.prototype = new v3sExerciseElement();

    v3sConnectionElement.prototype.setIsCorrectAnswer = function(isCorrectAnswer){
        this.isCorrectAnswer = isCorrectAnswer;
    }
    /*
     * Setzt die Eigenschaft isDrawn.
     * Danach wird die Antwort geprüft 
     * @param {boolean} isDrawn - Zeigt an, ob das Element gezeichnet wurde, oder nicht
     */
    v3sConnectionElement.prototype.setUserAnswer = function (isDrawn) {
        this.isDrawn = isDrawn;
        this.userAnswer.from = this.from;
        this.userAnswer.to = this.to;
        this.checkAnswer();
        this.save();
    }

    /*
     * Prüft die Antwort und setzt den Status des Elements
     */
    v3sConnectionElement.prototype.checkAnswer = function () {
        if (this.isDrawn) {
            if (this.isCorrectAnswer) {
                this.isCorrect = true;
                this.status = this.STATUS.CORRECT;
            } else {
                this.status = this.STATUS.FALSE;
            }
        } else {
            if (this.isCorrectAnswer) {
                this.status = this.STATUS.NO_ANSWER;
            } else {
                this.isCorrect = true;
                this.status = this.STATUS.CORRECT;
            }
        }
    }
    /**
    * Registriert das Element beim {@link v3sWbtPlayerApp:exercise.service_v3sExerciseService} und holt die letzte Auswertung
    * @memberOf v3sWbtPlayerApp:exercise.service_v3sExerciseElement
    * @return Auswertungsobjekt
    */
    //v3sConnectionElement.prototype.load = function () {
    //    v3sExerciseService.addExercise(this);
    //};
    v3sConnectionElement.prototype.save = function () {
        v3sExerciseService.updateExercise(this, { status: this.status, isCorrectAnswer :this.isCorrectAnswer, isDrawn : this.isDrawn, userAnswer: this.userAnswer, element : this.element });
    };
    v3sConnectionElement.prototype.updateShowFeedback = function (showFeedback) {
        delete this.showFeedback;
        this.setShowFeedback = showFeedback;
    }
    return v3sConnectionElement;
}]);
